// extracted by mini-css-extract-plugin
export default {"Alert":"Alert_Alert__C2kkg","InnerAlert":"Alert_InnerAlert__4DwEZ"};